import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "fontSize"],
  _excluded2 = ["children", "gap", "padding", "alignItems", "justifyContent", "margin", "maxInlineSize", "textAlign", "layout"];
import { Heading } from '../Typography/Heading';
import { LayoutBox } from '../Layout/LayoutBox';
import { Illustration } from '../Illustration/Illustration';
import { LayoutVertical } from '../Layout/LayoutVertical';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { jsx as _jsx } from "react/jsx-runtime";
const Title = _ref => {
  let {
      as = 'h5',
      fontSize = 'sm'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Heading, Object.assign({}, rest, {
    as: as,
    fontSize: fontSize
  }));
};
Title.displayName = 'EmptyState.Title';
export const EmptyState = _ref2 => {
  let {
      children,
      gap = 'space-lg',
      padding = 'space-lg',
      alignItems: alignItemsProvided,
      justifyContent: justifyContentProvided,
      margin = 'auto',
      maxInlineSize = '815px',
      textAlign: textAlignProvided,
      layout = 'vertical'
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const Layout = layout === 'vertical' ? LayoutVertical : LayoutHorizontal;
  const alignItems = alignItemsProvided || layout === 'vertical' ? 'center' : 'start';
  const textAlign = textAlignProvided || layout === 'vertical' ? 'center' : 'left';
  const justifyContent = justifyContentProvided || 'center';
  return /*#__PURE__*/_jsx(Layout, Object.assign({}, rest, {
    alignItems: alignItems,
    gap: gap,
    justifyContent: justifyContent,
    margin: margin,
    maxInlineSize: maxInlineSize,
    padding: padding,
    textAlign: textAlign,
    children: children
  }));
};
EmptyState.Illustration = props => /*#__PURE__*/_jsx(Illustration, Object.assign({}, props));
EmptyState.PrimaryContent = props => /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, props));
EmptyState.SecondaryContent = props => /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, props));
EmptyState.Title = props => /*#__PURE__*/_jsx(Title, Object.assign({}, props));